import {initialize as initializeLdClient} from 'ldclient-js';
import {ENV_CONFIGS} from '../constants/envs';
import {DEFAULT_FEATURE_FLAGS_VALUES, FEATURE_FLAGS} from '../constants/featureFlags';
import {v4 as getUUID} from 'uuid';

const anonymousUser = {key: getUUID(), anonymous: true};
let client;

export const initialize = (env, region, user = {}) =>
  new Promise(resolve => {
    // Reset initialized flag on each call to this function (which happens on each mount of issues-ui)
    let wasClientInitialized = false;

    // Initialize LD client
    // We use a random user id as we currently don't have any FFs per user and should
    // decide how we would like to identify our users when we do
    client = initializeLdClient(ENV_CONFIGS.LAUNCH_DARKLY.API_KEY, Object.assign({}, anonymousUser, user), {
      bootstrap: ENV_CONFIGS.LAUNCH_DARKLY.USE_DEFAULTS ? DEFAULT_FEATURE_FLAGS_VALUES : undefined,
      allAttributesPrivate: true
    });
    client.on('ready', () => {
      // If the LD client didn't initialize in time it means that we're now using default values.
      // So it's much safer to continue using them instead of switching between the two because they may be different.
      if (!wasClientInitialized) {
        wasClientInitialized = true;
        resolve();
      }
    });

    setTimeout(() => {
      if (!wasClientInitialized) {
        wasClientInitialized = true;
        // Faking out the client in case it didn't initialize in time.
        client = {
          variation(key, defaultValue) {
            return defaultValue;
          }
        };
        resolve();
      }
    }, 10000);
  });

export default {
  get(key) {
    if (!client) {
      console.warn(`Getting FF before initialization. FF: ${key}`);
    }
    const defaultFlagValue = DEFAULT_FEATURE_FLAGS_VALUES[key];
    const value = client ? client.variation(key, defaultFlagValue) : defaultFlagValue;
    // The convention for multi-variant values is that the "empty" value should be 'null'.
    // The rest of the values return as is.
    return value === 'null' ? null : value;
  }
};

export {FEATURE_FLAGS};
